import { WIDGET_MODAL, SPINNER_ID, SPINNER_WRAPPER_ID, MODAL, MODAL_OPEN, IFRAME_ID } from '../constants';

type WrapperData = {
  iframeWrapper: Node;
};

// Create a DOM element
const createElement = (elementName): any => document.createElement(elementName);

// Close and destroy a DOM element
const removeElement = (el: Node): void => {
  if (!el) throw new Error(`Failed to match: ${el}`);
  if (el.parentNode) el.parentNode.removeChild(el);
};

// Create Wrapper
const createWrapper = (el: Node): WrapperData => {
  // iframe wrapper
  const iframeWrapper = createElement('div');
  iframeWrapper.id = WIDGET_MODAL;
  iframeWrapper.classList.add(MODAL, MODAL_OPEN);
  el.appendChild(iframeWrapper);

  return { iframeWrapper };
};

// Create Spinner with a wrapper
const createSpinner = (el: Node): void => {
  // spinner
  const spinner = createElement('div');
  spinner.id = SPINNER_ID;

  // spinner wrapper
  const spinnerWrapper = createElement('div');
  spinnerWrapper.id = SPINNER_WRAPPER_ID;
  spinnerWrapper.appendChild(spinner);
  el.appendChild(spinnerWrapper);
};

// Remove Spinner with a wrapper
const removeSpinner = (): void => {
  const spinnerWrapperElem = document.getElementById(SPINNER_WRAPPER_ID);
  if (spinnerWrapperElem) removeElement(spinnerWrapperElem);
};

// Create Iframe
const createIframe = (iframeWrapper: Node, iframeUrl: string): void => {
  // iframe
  const iframe = createElement('iframe');
  iframe.id = IFRAME_ID;
  iframe.referrerPolicy = 'origin';
  iframe.src = iframeUrl;
  iframe.onload = removeSpinner;
  iframe.onerror = removeSpinner;
  if (iframeWrapper) iframeWrapper.appendChild(iframe);
};

// reload iframe
const reloadIframe = (): void => {
  const iframe: any = document.getElementById(IFRAME_ID);
  if (iframe) iframe.setAttribute('src', iframe.src);
};

// Remove Iframe with a wrapper
const clearSocket = (): void => {
  removeSpinner();
  const iframeWrapperElem = document.getElementById(WIDGET_MODAL);
  if (iframeWrapperElem) removeElement(iframeWrapperElem);
};

export { createIframe, createSpinner, createWrapper, clearSocket, removeSpinner, reloadIframe };
